import { render, staticRenderFns } from "./StudentOnBoarding.vue?vue&type=template&id=25d3dd33"
import script from "./StudentOnBoarding.vue?vue&type=script&lang=js"
export * from "./StudentOnBoarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports